<template lang="pug">
  div#app
    router-view
</template>
<script>
import { firebase } from '@/plugins/firebase'
import { version } from '../package.json'
export default {
  name: 'App',
  metaInfo: {
    titleTemplate: (titleChunk) =>
      titleChunk ? `${titleChunk} - relationEMS` : 'relationEMS',
    changed(metaInfo) {
      firebase.analytics().setCurrentScreen(metaInfo.title)
      firebase.analytics().logEvent('page_view')
      firebase.analytics().logEvent('screen_view', {
        app_name:
          window && window.matchMedia('(display-mode: standalone)').matches
            ? 'pwa'
            : 'web',
        screen_name: metaInfo.title,
        app_version: version,
      })
    },
  },
}
</script>

<style lang="scss">
/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
button {
  background: none;
  border: none;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
input,
textarea {
  border: none;
  -webkit-appearance: none;
}
svg {
  margin: 0;
}
select {
  border: none;
  outline: none;
  background: transparent;
  background-image: none;
  box-shadow: none;
  -webkit-appearance: none;
  appearance: none;
}
*:focus {
  outline: none;
}
* {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
a {
  cursor: pointer;
}
#app {
  * {
    font-family: BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen,
      Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial,
      sans-serif;
    -ms-overflow-style: none; /* IE, Edge 対応 */
    scrollbar-width: none; /* Firefox 対応 */
    ::-webkit-scrollbar {
      display: none;
    }
  }
  text-align: center;
  color: #333;
  -ms-overflow-style: none; /* IE, Edge 対応 */
  scrollbar-width: none; /* Firefox 対応 */
  ::-webkit-scrollbar {
    display: none; /* Chrome, Safari 対応 */
  }
  .error {
    font-size: 13px;
  }
  p {
    line-height: 1.7;
  }
  .tap_highlight {
    -webkit-tap-highlight-color: rgba(64, 64, 64, 0.34);
  }
}
::-webkit-scrollbar {
  display: none;
}

// 共通CSS（EMS特有）
</style>
